import Label from "../components/Label";
import PromoContent from "../components/PromoContent";

function Promo() {
  return (
    <div className="page">
      <h1 id="page-header">
        <Label number={157} />
      </h1>
      <div className="container">
        <PromoContent />
      </div>
    </div>
  );
}

export default Promo;
